<template>
  <b-button>{{ text }}</b-button>
</template>

<script>
export default {
  props: ['text']
}
</script>
